import React, { useEffect, useRef } from "react";

const GoogleMapWithCircle = () => {
  const mapRef = useRef(null); 
  const map = useRef(null); 
  const placeId = "ChIJ5S-raZk_zjgR6V0GYT_W0xE"; 

  useEffect(() => {
    const initMap = () => {
      if (!window.google || !window.google.maps) {
        console.error("Google Maps API failed to load.");
        return;
      }

      // Initialize the map
      map.current = new window.google.maps.Map(mapRef.current, {
        center: { lat: 31.5497, lng: 74.3436 }, 
        zoom: 14,
      });

      const service = new window.google.maps.places.PlacesService(map.current);

      service.getDetails(
        {
          placeId: placeId,
          fields: ["name", "geometry"],
        },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const location = place.geometry.location;
            const latitude = location.lat();
            const longitude = location.lng();

            // Add a marker
            const marker = new window.google.maps.Marker({
              position: { lat: latitude, lng: longitude },
              map: map.current,
              title: place.name,
            });

            // Center map on the marker
            map.current.setCenter(marker.position);

            // Add a circle around the marker
            new window.google.maps.Circle({
              strokeColor: "#0000FF",
              strokeOpacity: 0.5,
              strokeWeight: 2,
              fillColor: "#0000FF",
              fillOpacity: 0.2,
              map: map.current,
              center: marker.position,
              radius: 1500, // 1.5km radius
            });
          } else {
            console.error("Failed to fetch place details:", status);
          }
        }
      );
    };

    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      initMap();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBQWV9bYkdlr6yDS0yasWSdjik6hR6fBvE&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  return <div ref={mapRef} style={{ width: "100%", height: "550px" }} />;
};

export default GoogleMapWithCircle;
